The identifier for the `PositionOpening` to be deleted.
